import { axiosClient } from '../../../shared/api';

export const getProfile = async () => {
  const response = await axiosClient.get('/profile');
  return response.data;
};

export const getCompany = async () => {
  const response = await axiosClient.get('/profile/company');
  return response.data;
};

export const updateProfile = async (payload) => {
  const response = await axiosClient.put('/profile', payload);
  return response.data;
};

export const updateCompany = async (payload) => {
  const response = await axiosClient.put('/profile/company', payload);
  return response.data;
};

export const changePassword = async (payload) => {
  const response = await axiosClient.put('/profile/change-password', payload);
  return response.data;
};
